import React, { Component } from 'react';
import {Spacer, Button, InputInline} from 'app/components/Basics/'
import { Icons } from '@ecosystem/ui-lib/core/components/Icon';
import './GlobalControlLineComponent.scss';
import { ReactComponent as SaveIcon } from 'app/assets/icons/Save.svg';
import { ReactComponent as DuplicateIcon } from 'app/assets/icons/Duplicate-Plus.svg';
import {DynamicDemoFormContext} from '../../DynamicDemoContext'
import ValidateDynamicDemo from '../../DynamicDemoValidation'
 
class GlobalControlLine extends Component {

    constructor(props){
        super(props);

        this.state = {            
        }        
    }

    componentWillReceiveProps(nextProps) {        
        if (nextProps && nextProps.errors) {            
            var error = nextProps.errors.find(e => e.field === "name")
            if (error) {
                this.setState({errorDynamicDemoName: error.errorMessage})
            }
        }
    }

    getNewDynamicDemoName(isEditorOpen, newDynamicDemoName) {
        if (!isEditorOpen) {
            var selectedDynamicDemo = this.context.selectedDynamicDemo;
            selectedDynamicDemo.name = newDynamicDemoName;
            this.context.updateSelectedDynamicDemo(selectedDynamicDemo);
        }
    }
	
	isSaveDisabled() {
		let result = false;
		var errors = ValidateDynamicDemo(this.context.selectedDynamicDemo);		
		if (errors.length > 0) {
			result = true;
		}		
		if (!this.props.didSelectedDynamicDemoChange()) {
			result = true;
		}
		return result;
	}

	isNewDynamicDemo() {
		return this.context.selectedDynamicDemo.id === null;
	}	

	userCannotChangeData() {
		return !this.props.canChangeData;
	}

    render() {
        return (
            <div className="GlobalControlLineComponent form-row">
                {/* <InputInline disabled={this.userCannotChangeData()} enableOnBlur className="name-field" error={this.state.errorDynamicDemoName} value={this.context.selectedDynamicDemo.name} onModeChange={this.getNewDynamicDemoName.bind(this)} /> */}
                <div></div>
                <div className="contol-buttons">                    
                    <Button disabled={this.userCannotChangeData() || this.isSaveDisabled()} title="Save all changes in the survey" icon={<SaveIcon/>} onClick={this.props.handleSubmitAction}>Save</Button>                    
                    <Button title="Close current editor and discard all unsaved changes" onClick={this.props.closeEditorButtonOnClick} simple icon={Icons.Close}>Close</Button>
                    <Spacer width={20}/>                   
                    <Button disabled={this.userCannotChangeData() || this.isNewDynamicDemo()} title="Delete the dynamic demo is irreversible" small secondary icon={Icons.Delete} onClick={this.props.deleteDynamicDemo}>Delete</Button>
                    <Button disabled={this.userCannotChangeData() || this.isNewDynamicDemo()} title="Create a new dynamic demo as duplicate from this dynamic demo" small secondary icon={<DuplicateIcon/>} onClick={this.props.duplicateDynamicDemo}>Duplicate</Button>					
                </div>
                
            </div>  
        );
    }
}
GlobalControlLine.contextType = DynamicDemoFormContext;
export default GlobalControlLine;